import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';

import {
  resetCurrentSalesInvoice,
  fetchSalesInvoiceDetail,
} from '../../actions/salesInvoice_actions';
import {
  updateSalesInvoicePayment,
  resetSalesInvoicePayment,
} from '../../actions/salesInvoicePayment_actions';
import SIPaymentForm from '../../components/AR/SIPaymentForm/SIPaymentForm';

const validate = (values) => {
  const errors = {};
  if (!values.PaymentStatus) {
    errors.PaymentStatus = 'Required';
  }
  return errors;
};

const SIPayment = reduxForm({
  form: 'SIPaymentForm',
  validate,
})(SIPaymentForm);

const selector = formValueSelector('SIPaymentForm');

function mapStateToProps(state) {
  const paymentStatusRecord = selector(state, 'PaymentStatusRecord');

  return {
    paymentStatusRecord,

    salesInvoiceDetail: state.salesInvoice.currentSalesInvoiceDetail,
    detailIsLoading: state.salesInvoice.detailIsLoading,
    detailError: state.salesInvoice.detailError,

    updatedSalesInvoicePayment: state.salesInvoicePayment.updatedSalesInvoicePayment,
    updateSalesInvoicePaymentError: state.salesInvoicePayment.updateSalesInvoicePaymentError,
    salesInvoicePaymentIsUpdating: state.salesInvoicePayment.salesInvoicePaymentIsUpdating,
    salesInvoicePaymentUpdated: state.salesInvoicePayment.salesInvoicePaymentUpdated,

    initialValues: state.salesInvoice.currentSalesInvoiceDetail,
  };
}

export default connect(mapStateToProps, {
  resetCurrentSalesInvoice,
  fetchSalesInvoiceDetail,
  updateSalesInvoicePayment,
  resetSalesInvoicePayment,
})(SIPayment);



// WEBPACK FOOTER //
// ./master/jsx/containers/AR/SIPaymentForm.jsx